module.exports = __webpack_public_path__ + "img/2-Icon-Age.2d819605.png";